import React from 'react'
import { Button } from '@turretcss/react'
import classNames from 'classnames'

const Upload = ({ upload, onRemove, link = false }) => (
  <div className="text-align-center">
    <figure className="align-items-center flex flex-column">
      <div className="width-1">
        <a
          href={link ? upload : undefined}
          target="_blank"
          className={classNames('media media-1 background-light-grey', {
            'no-spinner': !isImage(upload),
          })}
        >
          {isImage(upload) ? (
            <img src={previewUrl(upload)} style={{ objectFit: 'contain' }} />
          ) : (
            <div className="cover flex justify-content-center align-items-center">
              {isVideo(upload) ? <VideoIcon /> : <PaperIcon />}
            </div>
          )}
        </a>
      </div>
      <figcaption className="text-align-center font-size-m margin-vertical-xsmall">
        <a href={link ? upload : undefined} target="_blank">
          {uploadName(upload)}
        </a>
      </figcaption>
    </figure>
    {onRemove && (
      <Button
        color="error"
        className="button-xsmall button-block button-border"
        onClick={() => confirm('Are you sure you want to remove this?') && onRemove(upload)}
      >
        Remove
      </Button>
    )}
  </div>
)

const PaperIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <path d="M13 38v3c0 3.33-3.5 3.92-4 4a4 4 0 0 1-4-4V3h32v32h2V1H3v40a6 6 0 0 0 6 6h30a6 6 0 0 0 6-6v-3zm30 3a4 4 0 0 1-4 4H13.41A5.49 5.49 0 0 0 15 41v-1h28z" />
    <path d="M11 27h20v2H11zm0-16h20v2H11zm0 8h20v2H11z" />
  </svg>
)

const VideoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
    <path
      d="M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5Z"
      fill="transparent"
      stroke="black"
    />
  </svg>
)

export function isUploadUrl(upload) {
  return typeof upload === 'string' && upload.match(/^https:\/\//i)
}

function uploadName(upload) {
  if (isUploadUrl(upload)) {
    return upload.replace(/^.+\/(.+)$/, '$1')
  }
  return upload.name
}

function previewUrl(upload, preset = 'upload') {
  if (isUploadUrl(upload)) {
    return upload
  }
  return `/generated/uploads/${preset}/${upload.id}.jpg`
}

function isImage(upload) {
  return uploadName(upload).match(/\.(jpg|jpeg|png|gif)$/i)
}

function isVideo(upload) {
  return uploadName(upload).match(/\.(mp4)$/i)
}

export default Upload
